import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import './Chip.scss';

const Chip = (props) => {
   let chipClasses = ClassNames(
      'chip',
      props.className
   );

   return (
      <button type="button" className={chipClasses} onClick={(e) => {
         if (props.onClick)
            props.onClick(e);
      }}>
         {props.icon ? <img src={props.icon}/> : null}
         <span>{props.children}</span>
      </button>);
};

Chip.propTypes = {
   /** CSS class names added by the user to the component */
   className: PropTypes.string,
   /** Icon to show in the chip */
   icon: PropTypes.string,
   /** Callback function to call when the chip is clicked */
   onClick: PropTypes.func,
   /** Children to show in the chip */
   children: PropTypes.any
};

export default Chip;
